import http from "../../http-common";

const handle = (promise) =>
  promise
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });

const getCatalog = async () => handle(http.get("/ultimate/messager/catalog"));

const messagesGetAll = async (params = {}) =>
  handle(http.get("/ultimate/messager/messages", { params }));

export default {
  getCatalog,
  messages: {
    getAll: messagesGetAll,
  },
};
